// extracted by mini-css-extract-plugin
export default {"wrap":"OrdersSunSatDaysModal_wrap__moFHF","inputGroup":"OrdersSunSatDaysModal_inputGroup__Uw66l"};